import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {ValidarService} from "./validar.service";
import {Global} from "../global";
import {FormBuilder, Validators, FormGroup} from "@angular/forms";
import {Funcoes} from '../funcoes';

@Component({
  selector: 'app-validar',
  templateUrl: './validar.component.html'
})
export class ValidarComponent implements OnInit {

  validouDOC = false;
  nomeSistema: string;
  copyright: string;

  urlPDF = '';
  cod = '';
  alturaTela;

  form: FormGroup;

  constructor(
    formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private validarService: ValidarService,
    public global: Global,
    private func: Funcoes
  ) {
    this.nomeSistema = global.nomeSistema;
    this.copyright = global.copyright;
    this.alturaTela = window.screen.availHeight;

    this.form = formBuilder.group({
      cod: ['', [
        Validators.required
      ]],
    });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['cod']) {
        this.cod = params['cod'];
        if (this.form && this.form.controls['cod']) {
          this.form.controls['cod'].setValue(this.cod);
        }
        this.validar();
      }
    });
  }

  validar() {
    if (!this.cod) return;

    this.urlPDF = '';
    this.validarService.validar(this.cod).subscribe(
      (data) => {
        if (data && data.Success) {
          this.urlPDF = this.global.dominio_site + '/pub/validar/' + this.cod + '/exibir-pdf';
          this.validouDOC = true;
        } else {
          this.func.showErro(data);
        }
      },
      (error) => {
        try {
          let json = error.json();
          this.func.showErro(json);
        } catch (e) {
          this.func.showErro(error);
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/validar/validar.component.ts